import 'react-app-polyfill/ie11';
import * as React from 'react';
import * as ReactDOM from "react-dom";
import * as classNames from "classnames";
import { DirectLine, Activity, IActivity } from 'botframework-directlinejs';
import ReactWebChat from 'botframework-webchat/lib';
import CroppedImage from "botframework-webchat-component/lib";
import { hooks } from "botframework-webchat-component/lib";
import createStore from 'botframework-webchat-core/lib/createStore';
import { Middleware, AnyAction } from 'redux';

interface AvatarProps {
    'aria-hidden': boolean | undefined,
    className: string | undefined,
    fromUser: string | undefined,
    initials: string | undefined,
    userName: string | undefined,
    color: string | undefined,
    fontColor: string | undefined,
}

const Avatar = ({ 'aria-hidden': ariaHidden, className, fromUser, initials, userName, color, fontColor }: Partial<AvatarProps>) => {
    //const [botAvatar] = useAvatarForBot();
    //const [userAvatar] = useAvatarForUser();
    const [{ avatar: avatarStyleSet }] = hooks.useStyleSet();

    const image = undefined;

    if(image || initials)
    {
        return (
            <div
                aria-hidden={ariaHidden}
                className={classNames.default(avatarStyleSet + '', { 'from-user': fromUser }, className + '')}
                title={userName}
                style={ { backgroundColor: color, color: fontColor } }
            >
                {initials}
                {!!image && <CroppedImage alt="" className="image" height="100%" src={image} width="100%" />}
            </div>
        );
    }
    return (<div></div>)
};

const renderAvatar = (element: any, userInitials: string, color: string | undefined, fontColor: string | undefined) => {
    ReactDOM.render(
        Avatar({
            initials: userInitials,
            color,
            fontColor,
        }),
        element
    );
}

interface ChatUser
{
    id: string;
    initials: string | undefined;
    color: string | undefined;
    fontColor: string | undefined;
    name: string;
}

// const activities: Activity[] = [
//     {
//       type: 'message',
//       id: '6266x5ZXhXkBfuIH0fNx0h-o|0000000',
//       timestamp: '2019-08-08T16:41:12.9397263Z',
//       from: {
//         id: 'dl_654b35e09ab4149595a70aa6f1af6f50',
//         name: 'm.grundner@delegate.at',
//         role: 'user'
//       },
//       textFormat: 'plain',
//       text: 'echo "Hello, World!"'
//     },
//     {
//       type: 'message',
//       id: '6266x5ZXhXkBfuIH0fNx0h-o|0000001',
//       timestamp: '2019-08-08T16:41:13.1835518Z',
//       from: {
//         id: 'webchat-mockbot',
//         name: 'webchat-mockbot',
//         role: 'bot'
//       },
//       text: 'Echoing back in a separate activity.'
//     },
//     {
//       type: 'message',
//       id: '6266x5ZXhXkBfuIH0fNx0h-o|0000002',
//       timestamp: '2019-08-08T16:41:13.3963019Z',
//       from: {
//         id: 'dl_654b35e09ab4149595a70aa6f1af6f50',
//         name: 't.steiner@delegate.at',
//         role: 'user'
//       },
//       text: 'Hello, World from TS!'
//     },
//   ];

let dispatcher: React.Dispatch<AnyAction> | undefined;
let currentChannelId: string | undefined;

const renderChatWindow = (element: Element, channelId: string, token:string, userID: string, userName:string, users: ChatUser[], activitiesString: string | undefined) => {
    const activities: Activity[] = activitiesString
        ? JSON.parse(activitiesString)
        : [];

    currentChannelId = channelId;

    const middleware: Middleware = ({ dispatch }) => (next) => (action) => {
            if(action.payload && action.payload.activity) {
                action.payload.activity.entities = action.payload.activity.entities ?? [];
                action.payload.activity.entities.push({
                    blazorChannelId: channelId
                });
        }
        return next(action);
    };

    const webchatStore = createStore({
        activities

    }, middleware);

    dispatcher = webchatStore.dispatch;

    const activityMiddleware = () => (next: any) => (card: any) => (children: any) => {
        let from = "";
        let isUser = false;
        let initials = "";
        let color: string | undefined = undefined
        let fontColor: string | undefined = undefined

        const activity: Activity = card.activity;

        if (activity.from && activity.from.role && activity.from.name) {
            from = activity.from.name;

            const user = users.find(u => u.name === from);
            if(user && user.color)
            {
                color = user.color;
            }
            if(user && user.fontColor)
            {
                fontColor = user.fontColor;
            }
            if(user && user.initials){
                initials = user.initials;
            } else if(user) {
                const name = user.name.replace(/[^a-zA-Z]/gi, '');
                if(name.length >= 2){
                    initials = name.slice(0,2).toLocaleUpperCase();
                }
            }else {
                initials = "BT";
            }

            if (activity.from.name !== userName) {
                activity.from.role = 'bot';
            } else {
                isUser = true;
            }
        }

        if((window.external as any) == 'BlazorChatWinForms.BlazorScriptingObject') {
            (window.external as any).ActivityIsIncomming(from, isUser, initials, color, fontColor, JSON.stringify(activity));
        }

        return (
            <div>
                <div style={{ float: isUser ? 'right' : 'left', padding: "0 0.5rem" }}>
                    <Avatar initials={initials} userName={from} color={color} fontColor={fontColor} />
                </div>{next(card)(children)}</div>
        )
    };

    const dl = new DirectLine({
        token
    });

    ReactDOM.render(
        <ReactWebChat
            store={webchatStore}
            activityMiddleware={activityMiddleware}
            className="chat"
            username={userName}
            userID={userID}
            directLine={dl}
            />,
        element
    );
    element.setAttribute("style", "overflow: hidden; flex-grow: 1;");
}

const focusChatTextBox = (element: Element) =>{
    const childElement: HTMLInputElement | null = element.querySelector("input");
    if(childElement && childElement.focus) {
        window.setTimeout(() => {
            childElement.focus();
            console.error("focus called");
        }, 200);
    }
};

const sendActivity = (type: string, payload: IActivity | string) => {
    if(typeof payload === 'string'){
        payload = JSON.parse(payload) as IActivity;
    }
    if(payload)
    {
        (payload as any).entities = (payload as any).entities ?? [];
        (payload as any).entities.push({
            blazorChannelId: currentChannelId
        });
    }

    if(dispatcher){
        dispatcher({
            type,
            payload: payload
        })
    }
}

export { renderChatWindow, renderAvatar, focusChatTextBox, sendActivity };
